import React from 'react'


const AnimatedText = ({ children }) => {
  return (
    <div
      className="font-sans text-transparent"
      style={{
        animation: 'flow 10s ease-in-out infinite',
        background: `linear-gradient(
          122.26deg,
          var(--color-secondary),
          var(--color-secondary),
          #ffffff,
          var(--color-secondary),
          #ffffff
        )`,
        backgroundSize: '200%',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      }}
    >
      {children}
    </div>
  )
}

export default AnimatedText
